import React, { MouseEvent } from "react";
import { Segment } from "@/types/types.ts";
import { ContextMenuTypes } from "@/enum/contextMenuTypes.ts";
import usePlayingSegment from "@/common/hooks/usePlayingSegment.ts";
import useCurrentContextMenu from "@/common/hooks/useCurrentContextMenu.ts";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import { GridRow, GridRowProps } from "@mui/x-data-grid-pro";
import useUserIsWriting from "@/common/hooks/useUserIsWriting.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import {
  SegmentTableRowPlayer,
} from "@/features/AudioWorkstation/components/AudioEditorTabs/EditorTabPane/SegmentTableRowPlayer.tsx";
import { FlexBox } from "@/common/components/Box/FlexBox.tsx";

export type SegmentTableRowProps = {
  row: Segment;
} & GridRowProps;

const SegmentTableRow = (props: SegmentTableRowProps) => {
  const { row } = props;
  const segment = row as Segment;
  const [playingSegment] = usePlayingSegment();
  const { play, seek } = useAudioPlayback();
  const currentExplorerItem = useCurrentExplorerItem();
  const [, setCurrentContextMenu] = useCurrentContextMenu();
  const userIsWriting = useUserIsWriting();

  const playSegment = (segment: Segment) => {
    if (currentExplorerItem && playingSegment && playingSegment.id === segment.id) {
      play(currentExplorerItem);
      return;
    }

    replaySegment(segment);
  };

  const replaySegment = (segment: Segment) => {
    if (!currentExplorerItem) {
      console.log("Warning: currentExplorerItem is not defined @ SegmentTableRow.replaySegment");
      return;
    }

    seek(segment.startTime);
    play();
  };

  return (
    <FlexBox
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // backgroundColor:
        //   playingSegment?.id === segment.id
        //     ? getCssVariable("--mui-palette-background-level3")
        //     : "none",
      }}
    >
      <GridRow
        onDoubleClick={() => {
          if (userIsWriting()) {
            return;
          }
          playSegment(segment);
        }}
        onContextMenu={(mouseEvent: MouseEvent) => {
          mouseEvent.preventDefault();
          setCurrentContextMenu({
            type: ContextMenuTypes.TABLE_ROW_SEGMENT,
            data: {
              segment,
              mouseEvent,
            },
          });
        }}
        {...props}
      />
      {playingSegment?.id === segment.id && <SegmentTableRowPlayer segment={segment} />}
    </FlexBox>
  );
};

export { SegmentTableRow };
